/**
 * 이미지 섹션이 다루는 한 장 — "서버 저장본"과 "저장 전 신규 업로드"는 배타 상태다.
 * 판별 유니온으로 표현해 (url 도 localUrl 도 없는) 무의미한 조합을 타입에서 막는다.
 */
export type ImageEntry =
  | {
      readonly kind: 'saved';
      readonly key: string;
      /** 서버 발급 표시 URL. */
      readonly url: string;
    }
  | {
      readonly kind: 'new';
      readonly key: string;
      /** 방금 고른 파일의 브라우저 로컬 미리보기 URL — 저장 전에도 눈으로 확인. */
      readonly localUrl: string;
    };

/** index 위치의 항목을 direction 방향으로 한 칸 옮긴 새 배열. 경계 밖 이동은 그대로. */
export const movedEntry = (
  list: readonly ImageEntry[],
  index: number,
  direction: -1 | 1,
): ImageEntry[] => {
  const to = index + direction;

  if (to < 0 || to >= list.length) {
    return [...list];
  }

  const next = [...list];
  const [target] = next.splice(index, 1);

  if (target) {
    next.splice(to, 0, target);
  }

  return next;
};
